// @flow
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "semantic-ui-less/semantic.less";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from "./components/App";
import ThemeContext from "./context/theme";
import store from "./store";
import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

const ReactApp = () => {
  const [isDark, setIsDark] = React.useState(false);
  const [fontSize, setFontSize] = React.useState("normal");

  const toggleDarkMode = () => {
    setIsDark((value) => !value);
  };

  const changeFontSize = (size) => {
    setFontSize(size);
  };

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <ThemeContext.Provider
        value={{ isDark, fontSize, changeFontSize, toggleDarkMode }}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeContext.Provider>
    </BrowserRouter>
  );
};

if (rootElement == null) {
  throw new Error("empty element");
} else {
  ReactDOM.render(<ReactApp />, rootElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
